import { axiosCore } from './http-core-service';
import { BillsPaginationDto } from './dtos/bills-pagination.dto';

/**
 * Appel API récupérant les factures paginées
 * @param contractId Contrat dont les factures sont à récupérer
 * @param page Page à récupérer
 * @param rowsPerPage Nombre d'éléments par page
 * @param sort tri des éléments
 */
export const getBills = async (
    contractId: string,
    page: number,
    rowsPerPage: number,
    sort?: string
): Promise<BillsPaginationDto> => {
    const response = await axiosCore.get(
        `/rattachement_contrats/${contractId}/factures?page=${page}&itemsPerPage=${rowsPerPage}&pagination=true` + sort
    );
    return {
        bills: response.data['hydra:member'],
        totalItems: response.data['hydra:totalItems'],
    };
};

/**
 * Appel API récupérant la dernière facture
 * @param contractId Contrat concerné
 */
export const getLastBill = async (contractId: string | undefined): Promise<BillsPaginationDto> => {
    const response = await axiosCore.get(
        `/rattachement_contrats/${contractId}/factures?page=1&itemsPerPage=1&pagination=true&order[facture.date_emission]=desc`
    );
    return {
        bills: response.data['hydra:member'],
        totalItems: response.data['hydra:totalItems'],
    };
};

/**
 * Récupère le contenu de la facture en base64 pour l'ouverture en PDF.
 * @param contractId Id du contrat
 * @param billRef Référence de la facture
 */
export const getBillBase64 = async (contractId: string, billRef: string): Promise<string> => {
    const response = await axiosCore.get(`/rattachement_contrats/${contractId}/factures/${billRef}/content`);
    return response.data['contenu'];
};
